/* B12 landing page — side cart integration & discount display */
(function () {
  var B12_VARIANT_ID = 46582155051235;
  // LP discount amounts in cents: 3-month=$38 off, 6-month=$149 off
  var LP_DISCOUNTS = { 3: 3800, 6: 14900 };

  function getDiscountForQty(qty) {
    if (qty >= 6) return { code: 'B12-6MO', cents: LP_DISCOUNTS[6] };
    if (qty >= 3) return { code: 'B12-3MO', cents: LP_DISCOUNTS[3] };
    return null;
  }

  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function patchCheckoutBtn(sc) {
    if (!sc || !sc._drawer) return;
    var btn = sc._drawer.querySelector('#sc-checkout-btn');
    if (!btn) return;
    // Clone to strip the original '/checkout' listener
    var fresh = btn.cloneNode(true);
    btn.parentNode.replaceChild(fresh, btn);
    fresh.addEventListener('click', function () {
      fresh.disabled = true;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var b12qty = (data.items || [])
            .filter(function (i) { return i.variant_id === B12_VARIANT_ID; })
            .reduce(function (s, i) { return s + i.quantity; }, 0);
          var disc = getDiscountForQty(b12qty);
          window.location.href = disc
            ? '/checkout?discount=' + disc.code
            : '/checkout';
        })
        .catch(function () {
          window.location.href = '/checkout';
        });
    });
  }

  function patchFooterTotal(sc) {
    if (!sc) return;
    var orig = sc._renderFooterTotal.bind(sc);
    sc._renderFooterTotal = function (cart) {
      // Run the original renderer first
      orig(cart);

      // Check for B12 LP items
      var b12qty = (cart.items || [])
        .filter(function (i) { return i.variant_id === B12_VARIANT_ID; })
        .reduce(function (s, i) { return s + i.quantity; }, 0);

      var disc = getDiscountForQty(b12qty);
      if (!disc || !cart.item_count) return;

      var fullCents = cart.total_price || 0;
      var discountedCents = fullCents - disc.cents;
      if (discountedCents < 0) discountedCents = 0;
      var pctOff = Math.round((disc.cents / fullCents) * 100);

      var footerRight = sc._drawer.querySelector('#sc-footer-total-right');
      if (footerRight) {
        footerRight.innerHTML =
          '<span class="sc-pct-off-pill">' + pctOff + '% Off</span>' +
          '<s class="sc-footer-compare">' + fmtMoney(fullCents) + '</s>' +
          '<span class="sc-footer-amount">' + fmtMoney(discountedCents) + '</span>';
      }
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sc = window.SourseCart;

    if (sc) {
      patchCheckoutBtn(sc);
      patchFooterTotal(sc);
    } else {
      // Fallback: patch LP's own simple checkout button if side cart absent
      var btn = document.getElementById('checkout-btn');
      if (!btn) return;
      var fresh = btn.cloneNode(true);
      btn.parentNode.replaceChild(fresh, btn);
      fresh.addEventListener('click', function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var qty = data.items.reduce(function (s, i) { return s + i.quantity; }, 0);
            var disc = getDiscountForQty(qty);
            window.location.href = disc
              ? '/checkout?discount=' + disc.code
              : '/checkout';
          });
      });
    }
  });
})();
